import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'sortBy',
})
export class SortByPipe implements PipeTransform {
  transform(
    value: any[],
    column: string,
    order: 'asc' | 'desc' = 'asc'
  ): any[] {
    if (isEmpty(value)) {
      return value;
    } // no array

    //getting custom sorter function
    return this.getSorter(value, column, order);
  }

  /**
   * @description This function returns a sorter function which sorts based on the provided column.
   *              This function sort the data with numbers priority.
   *              If any data does not contain number, the sorting will be based on alphabetical order
   * @param { string } value
   * @param { string } column
   * @param { string } order
   * @returns
   */
  getSorter(value: any[], column: string, order: string) {
    const sorted = value
      ?.filter((data: any) => data.hasOwnProperty(column))
      ?.sort((accessPointA: any, accessPointB: any) =>
        accessPointA[column]!.localeCompare(accessPointB[column]!, 'en', {
          numeric: true,
        })
      );

    if (order === 'desc') {
      sorted.reverse();
    }
    return sorted;
  }
}
